import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { gsap } from 'gsap';

const Wrapper = styled.header`
  position: sticky;
  top: 0;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  z-index: 100;
`;

const Bar = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Brand = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text);
  font-weight: 800;
  text-decoration: none;
`;

const Logo = styled.img`
  height: 28px;
  width: auto;
`;

const Links = styled.nav`
  display: inline-flex;
  align-items: center;
  gap: 18px;
`;

const Item = styled(NavLink)`
  color: var(--text);
  text-decoration: none;
  font-weight: 600;
  padding: 6px 2px;
  border-bottom: 2px solid transparent;
  &.active { color: var(--accent); border-color: var(--accent); }
  &:hover { color: var(--accent); }
`;

const Nav = () => {
  const { items } = useCart();
  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  const brandRef = useRef(null);
  const linksRef = useRef(null);
  const barRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (brandRef.current) {
        gsap.from(brandRef.current, { y: -10, autoAlpha: 0, duration: 1, ease: 'power2.out' });
      }
      if (linksRef.current) {
        gsap.from(linksRef.current.children, { y: -8, autoAlpha: 0, duration: 1, ease: 'power2.out', stagger: 0.08, delay: 0.15 });
      }
    }, barRef);
    return () => ctx.revert();
  }, []);

  return (
    <Wrapper ref={barRef}>
      <Bar>
        <Brand ref={brandRef} to="/" aria-label="Lamar's Clothes">
          <Logo src="/logo.svg" alt="Lamar's Clothes" />
        </Brand>
        <Links ref={linksRef}>
          <Item to="/" end>Home</Item>
          <Item to="/products">Products</Item>
          <Item to="/contact">Contact</Item>
          <Item to="/cart">Cart({count})</Item>
        </Links>
      </Bar>
    </Wrapper>
  );
};

export default Nav;
